import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const Image = React.forwardRef(({ data, onLoad }, ref) => {
  return <Img src={data.imageUrl} alt="" ref={ref} onLoad={onLoad} />
})

Image.displayName = 'Image'

Image.propTypes = {
  file: PropTypes.object,
  onLoad: PropTypes.func
}

const Img = styled.img`
  width: 100%;
  pointer-events: none;
  user-select: none;
`
